var map = {
	"./css/Themes.css": 15015,
	"./css/accordion.react.css": 79056,
	"./css/animationJackpot.css": 33749,
	"./css/application.css": 80799,
	"./css/bottomSheet.css": 56147,
	"./css/jackpot.css": 31815,
	"./css/newCss.css": 32114,
	"./css/sidebar-menu.css": 12897,
	"./css/tolkits.css": 95327,
	"./css/viax.css": 50841,
	"./fonts/TruenoRound.otf": 25153,
	"./fonts/TruenoRoundBd.otf": 12547,
	"./fonts/TruenoRoundBdIt.otf": 68336,
	"./fonts/TruenoRoundIt.otf": 40838,
	"./img/AppPromoBackground-removebg.png": 66540,
	"./img/Betnare-Jukwaa-Log.png": 83484,
	"./img/Betnare-Jukwaa-Logo.png": 79441,
	"./img/BetniMoto.webp": 46805,
	"./img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg": 71277,
	"./img/GetItOnGooglePlay_Badge_Web_color_English.png": 98843,
	"./img/Huawei_AppGallery_Badge_Color_Type=Black_Language=EN.svg": 83289,
	"./img/Logo-fire.webp": 92064,
	"./img/Logo.webp": 72365,
	"./img/Phones-removebg (1).png": 19449,
	"./img/aniversary.jpeg": 279,
	"./img/apk.png": 80940,
	"./img/auth/18only.png": 40866,
	"./img/auth/img-17.webp": 82167,
	"./img/aviator.png": 98716,
	"./img/aviator.webp": 32508,
	"./img/banner/customer-care/Customer_Care_Banner.webp": 21433,
	"./img/banner/customer-care/Paybill.webp": 18093,
	"./img/banner/print-matches/FOOTER.jpg": 25518,
	"./img/banner/print-matches/HEADER.jpg": 22912,
	"./img/banner/products/Aviator_Mobile.webp": 88191,
	"./img/banner/products/Bet_Nare_20_Stake_Booster_Mobile.webp": 90906,
	"./img/banner/products/Bet_Nare_20_gift_Mobile.webp": 90375,
	"./img/banner/products/Bet_Nare_3000_karibu_gift_Mobile.webp": 49863,
	"./img/banner/products/Bet_Nare_300k_Jackpot_Mobile.webp": 71711,
	"./img/banner/products/FPL.webp": 99736,
	"./img/banner/products/drops-and-wins.jpg": 87026,
	"./img/banner/products/jackpot-bg.jpg": 38730,
	"./img/banner/products/jackpot.webp": 26696,
	"./img/banner/products/mobile-jp.jpg": 5963,
	"./img/bannerBackground.png": 43586,
	"./img/contact-24.png": 3359,
	"./img/default_sport.svg": 98486,
	"./img/down-arrow.svg": 99778,
	"./img/favicon.png": 90286,
	"./img/fazi.jpg": 46840,
	"./img/leagues/Bundesliga.svg": 30171,
	"./img/leagues/LaLiga.svg": 94991,
	"./img/leagues/Ligue 1.svg": 63646,
	"./img/leagues/Premier League.svg": 48816,
	"./img/leagues/Serie A.svg": 2304,
	"./img/leagues/UEFA Champions League.svg": 29781,
	"./img/mobile/Aviator.svg": 95771,
	"./img/mobile/Casino.svg": 80786,
	"./img/mobile/FPL-MOBILE-2024.webp": 1861,
	"./img/mobile/Home.svg": 39918,
	"./img/mobile/Jackpot.svg": 87619,
	"./img/mobile/League.svg": 4484,
	"./img/mobile/Live.svg": 43329,
	"./img/mobile/MyBets.svg": 18565,
	"./img/mobile/Profile.svg": 50302,
	"./img/mobile/caution.png": 92960,
	"./img/mobile/close_icon.png": 62415,
	"./img/mobile/crash.svg": 47916,
	"./img/mobile/facebook.svg": 3591,
	"./img/mobile/fpl.png": 89745,
	"./img/mobile/fplmobile.webp": 59687,
	"./img/mobile/jet.svg": 46920,
	"./img/mobile/twitter.svg": 36240,
	"./img/mobile/whatsapp.svg": 11137,
	"./img/mpesa-3.png": 69718,
	"./img/mpesa.png": 87806,
	"./img/padlock.svg": 92444,
	"./img/phones.png": 36503,
	"./img/pragmatic.png": 68470,
	"./img/smartsoft.jpg": 6513,
	"./img/spribe.webp": 40353,
	"./img/under-maintenance.svg": 85358,
	"./settings/Gear.svg": 95881,
	"./svg/2316003_ball_courts_football_sports_icon.svg": 38365,
	"./svg/24-hours-delivery.svg": 51764,
	"./svg/24-hours.svg": 20971,
	"./svg/403.svg": 48442,
	"./svg/404.svg": 55621,
	"./svg/500.svg": 44416,
	"./svg/503.svg": 89075,
	"./svg/League of Legends.svg": 62833,
	"./svg/add.svg": 49892,
	"./svg/bet.svg": 95116,
	"./svg/betslip.svg": 88854,
	"./svg/casino.svg": 48806,
	"./svg/casino/diamond-level.png": 81488,
	"./svg/casino/levels-bronze.png": 73771,
	"./svg/casino/levels-gold.png": 50057,
	"./svg/casino/levels-silver.png": 84624,
	"./svg/comet-crash.svg": 64539,
	"./svg/default_sport.svg": 15305,
	"./svg/facebook-logo.svg": 52025,
	"./svg/fav-casino.svg": 66230,
	"./svg/fire.svg": 60995,
	"./svg/football-stadium-svgrepo-com.svg": 12603,
	"./svg/home.svg": 83130,
	"./svg/hourglass-svgrepo.svg": 73374,
	"./svg/icon.svg": 19584,
	"./svg/instagram.svg": 56137,
	"./svg/jackpot.svg": 41887,
	"./svg/jet.svg": 54468,
	"./svg/kenya.svg": 21009,
	"./svg/opened-email-envelope.svg": 61076,
	"./svg/padlock-dark.svg": 31956,
	"./svg/padlock.svg": 70031,
	"./svg/spaceman.svg": 63181,
	"./svg/sports/American Football.svg": 81614,
	"./svg/sports/Aussie Rules.svg": 80750,
	"./svg/sports/Badminton.svg": 22349,
	"./svg/sports/Baseball.svg": 64913,
	"./svg/sports/Basketball.svg": 920,
	"./svg/sports/Boxing.svg": 60200,
	"./svg/sports/Cricket.svg": 79202,
	"./svg/sports/Darts.svg": 55325,
	"./svg/sports/Futsal.svg": 79858,
	"./svg/sports/Gaerlic Hurling.svg": 31401,
	"./svg/sports/Handball.svg": 45141,
	"./svg/sports/Ice Hockey.svg": 75217,
	"./svg/sports/MMA.svg": 60128,
	"./svg/sports/MMA3.svg": 56483,
	"./svg/sports/Motorsport.svg": 59962,
	"./svg/sports/My Bets.svg": 6261,
	"./svg/sports/Rugby.svg": 45674,
	"./svg/sports/Soccer.svg": 47652,
	"./svg/sports/Table Tennis.svg": 51796,
	"./svg/sports/Tennis.svg": 15840,
	"./svg/sports/Volleyball.svg": 83005,
	"./svg/sports/Waterpolo.svg": 94046,
	"./svg/sports/aviator.svg": 33389,
	"./svg/sports/default_sport.svg": 52855,
	"./svg/sports/eSoccer.svg": 46379,
	"./svg/twitter-logo-on-black-background.svg": 3185,
	"./svg/whatsapp.svg": 28965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;